export default __webpack_public_path__ + "static/media/mini-chicken-wraps.8b5e7c6e.jpg";